import { settings } from './../settings';
import { tools } from './../helpers/tools';
import { opus } from './../api/opus';
import { configuration } from '../api/configuration';

class LastMinute {
    constructor(underscore, geo) {
        this._ = underscore;
        this.geo = geo;
        this.region = null;
        this.treatment = null;
        this.config = null;
        this.timeSlots = null;
        this.filteredTimeSlots = [];
        this.city = null;
    }

    init(newSettings) {
        
        const self = this;
        settings.init(newSettings);
        opus.init();
        //self.geo.init(google, null);
        //self.city = window.location.hash.substr(1);
        const urlParams = new URLSearchParams(window.location.search);
        self.city = urlParams.get('city');

        configuration
            .get()
            .then(config => {
                self.config = config.result;
                return opus.getTreatments();
            })
            .then(() => {
                self.treatments = opus.treatments.filter(treatment => {
                    return tools.inArray(self.config.lastMinute.treatments, treatment.id, 'treatmentId');
                });
                self.load();
            })
            .catch(response => {
                tools.handleError(self, response, $('#hd-lastminute-error'));
            });
    }

    load() {
        const self = this;

        $('#hd-filter-treatments').html(`<option value="">${settings.resources.all}</option>`);

        for (let i = 0; i < self.treatments.length; i++) {
            $('#hd-filter-treatments').append(`<option value="${self.treatments[i].id}">${self.treatments[i].name}</option>`);
        }

        if (settings.settings.regions && settings.settings.regions.length > 0) {
            // self.geo.calculateDistances(settings.settings.regions, regions => {
            //     if (regions) {
            //         settings.settings.regions = regions;
            //     }

                if (self.city) {
                    const selectedCity = tools.findByValue(settings.settings.regions, 'city', decodeURIComponent(self.city));
                    self.region = selectedCity ? selectedCity : settings.settings.regions[0];
                    // self.region = tools.findByValue(settings.settings.regions, 'city', decodeURIComponent(self.city));
                } else {
                    self.region = settings.settings.regions[0];
                }

                $('#hd-filter-city').html('');
                for (let i = 0; i < settings.settings.regions.length; i++) {
                    $('#hd-filter-city').append(
                        `<option${self.region.city == settings.settings.regions[i].city ? ' selected' : ''}>${
                            settings.settings.regions[i].city
                        }</option>`
                    );
                }

                $('#hd-filter-city')
                    .off('change')
                    .on('change', () => {
                        $('#hd-time-notimeslots').hide();

                        self.region = tools.findByValue(
                            settings.settings.regions,
                            'city',
                            $('#hd-filter-city option:selected').text()
                        );
                        self.getTimeSlots();
                    });

                $('#hd-filter-treatments')
                    .off('change')
                    .on('change', () => {
                        $('#hd-time-notimeslots').hide();

                        self.treatment = tools.findByValue(
                            opus.treatments,
                            'id',
                            +$('#hd-filter-treatments option:selected').val()
                        );
                        self.getTimeSlots();
                    });

                self.getTimeSlots();
            // });
        }
    }

    getTimeSlots() {
        const self = this;
        const now = new Date();
        const dates = [now];
        const filteredClinics = [];
        const container = $('#hd-time-rows');

        let maxDate = tools.addHoursToDate(self.config.lastMinute.includeTimeSlotsWithin, now);
        let days = Math.ceil(self.config.lastMinute.includeTimeSlotsWithin / 24) + 1;

        for (let i = 1; i < days; i++) {
            const date = tools.addDaysToDate(i, now);

            if (!(date.getDay() % 6)) {
                // Weekend, add a day and skip in result
                maxDate = tools.addDaysToDate(1, maxDate);
                days++;
            } else {
                dates.push(date);
            }
        }

        container.html('<div class="spinner-border" role="status"></div>').show();

        opus.getClinics()
            .then(() => {
                for (let i = 0; i < self.region.clinics.length; i++) {
                    if (tools.inArray(self.config.lastMinute.clinicIds, self.region.clinics[i].id))
                        filteredClinics.push(self.region.clinics[i]);
                }

                if (self.timeSlots && self.timeSlots.length > 0) {
                    self.showTimeSlots(container, filteredClinics);
                    if (self.filteredTimeSlots.length == 0) {
                        $('#hd-time-notimeslots').show();

                        $('#hd-time-rows').hide();
                    }
                    return Promise.resolve();
                } else {
                    return opus
                        .getTimeSlotsForDays(dates, self.treatments, maxDate, null, response => {
                            self.showTimeSlots(container, filteredClinics, response);
                        })
                        .then(() => {
                            if (self.filteredTimeSlots.length == 0) {
                                $('#hd-time-notimeslots').show();

                                $('#hd-time-rows').hide();
                            }
                        });
                }
            })
            .then(() => {})
            .catch(response => {
                tools.handleError(self, response, $('#hd-lastminute-error'));

                container.html('');
            });
    }

    showTimeSlots(container, filteredClinics, response) {
        const self = this;
        const template = self._.template($('#tmpl-hd-time-row').html()),
            treatments = self.treatment ? [tools.findByValue(self.treatments, 'id', self.treatment.id)] : self.treatments;

        self.timeSlots = response ? response.result : self.timeSlots;

        self.filteredTimeSlots = self.timeSlots.filter(timeSlot => {
            if (!timeSlot.discountedPrice) return false;

            if (tools.inArray(treatments, timeSlot.treatmentId, 'id'))
                return tools.inArray(filteredClinics, timeSlot.clinicId, 'id');

            return false;
        });

        if (self.filteredTimeSlots.length == 0) {
            $('#hd-time-rows').hide();
        } else {
            $('#hd-time-rows').show();

            $('#hd-time-notimeslots').hide();
        }

        container.html('');
        self.filteredTimeSlots.forEach(timeSlot => {
            if (!timeSlot.clinic) {
                timeSlot.clinic = tools.findByValue(opus.clinics, 'id', timeSlot.clinicId);
                timeSlot.clinic.name = timeSlot.clinic.name.replace('Happident ', '');
            }

            if (!timeSlot.treatment) {
                timeSlot.treatment = tools.findByValue(opus.treatments, 'id', timeSlot.treatmentId);
            }

            container.append(template(timeSlot));
        });

        $('.hd-selecttimeslot')
            .off('click')
            .on('click', function(e) {
                e.preventDefault();

                self.selectTimeSlot($(this).data('id'), $(this).data('clinicid'), $(this).data('start'));
            });
    }

    selectTimeSlot(id, clinicId, start) {
        const self = this;

        let timeSlot = opus.findTimeSlot(self.timeSlots, id, clinicId, start);
        if (timeSlot) {
            window.location = encodeURI(
                `/boka-tid/#${timeSlot.clinicId},${timeSlot.id},${timeSlot.start},${timeSlot.end},${timeSlot.clinicianId},${timeSlot.treatmentId},${timeSlot.discountedPrice},/sista-minuten`
            );
        }
    }
}

(function(hd, _) {
    hd.views = hd.views || {};
    hd.views.lastminute = new LastMinute(_, hd.views.geo);
    // eslint-disable-next-line no-undef
})((window.hd = window.hd || {}), _);



// WEBPACK FOOTER //
// ./scripts/booking/views/lastminute.js